
import Event = createjs.Event;

export class Poker2AchievementStatsEvent extends Event {
    public params: any[];

    public static CHANGE_TAB_ACHIEVEMENTS: string = "changeTabAchievements";
    public static CHANGE_TAB_STATISTICS: string = "changeTabStatistics";

    constructor(type: string, params: any[] = null, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);

        this.params = params;
    }
}
